/**
 * Defines all creation sources.
 */
export enum CreationSources {
  API = 0,
  DASHBOARD = 1,
  SDK = 2,
  IOS_SDK = 3,
  ANDROID_SDK = 4,
  WEB_SDK = 5,
  DYNAMIC = 6,
  THIRD_PARTY = 7,
}

/**
 * Defines all creation source names.
 */
export const creationSourceNames: { [key in CreationSources]: string } = {
  [CreationSources.API]: 'API',
  [CreationSources.DASHBOARD]: 'Dashboard',
  [CreationSources.SDK]: 'SDK',
  [CreationSources.IOS_SDK]: 'iOS SDK',
  [CreationSources.ANDROID_SDK]: 'Android SDK',
  [CreationSources.WEB_SDK]: 'Web SDK',
  [CreationSources.DYNAMIC]: 'Dynamic',
  [CreationSources.THIRD_PARTY]: 'Third Party',
};
